import { render, staticRenderFns } from "./PgConfigIframe.vue?vue&type=template&id=044bbd64&"
import script from "./PgConfigIframe.vue?vue&type=script&lang=ts&"
export * from "./PgConfigIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports